<template>
    <base-dialog :loading="loading" :value="dialog" :title="$t('common.pain_scale')" :width="400" @input="onDialogInput" @close="hide">
        <div class="pain-wrap">
            <div class="pain-end">{{ $t('common.much_pain') }}</div>
            <kimsa-rpe-slider :value="scale" :min="0" :max="10" @change="scale = Number($event)" ref="scale" />
            <div class="pain-end">{{ $t('common.no_pain') }}</div>
        </div>
        <template #footer>
            <v-btn class="footer-btn" depressed block @click="save" :loading="loading">
                {{ $t('common.save') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import KimsaRpeSlider from "@/components/common/inputs/KimsaRpeSlider";

export default {
    components: { BaseDialog, KimsaRpeSlider },
    name: "PainScaleDialog",
    props: {
        exercise: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            scale: 5,
        }
    },
    methods: {
        show() {
            this.scale = 5
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onDialogInput(val) {
            if (!val) this.hide()
        },
        save() {
            const vm = this;
            vm.$emit('success', vm.scale)
            vm.hide()
        }
    },
}
</script>

<style scoped>
.pain-wrap {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 4px 0;
}

.pain-end {
    text-transform: uppercase;
    font-weight: 700;
    text-align: center;
    color: var(--v-txtSecondary-base);
    font-size: var(--fs-caption);
}

.footer-btn.v-btn {
    height: 52px !important;
    border-radius: 0 !important;
    text-transform: none;
    letter-spacing: normal;
    font-weight: 700;
    box-shadow: none !important;
    background: var(--v-primary-base) !important;
    color: #0C0E12 !important;
}
</style>
